<template>
  <div>
    <div>
      <breadcrumb :breadcrumb="breadcrumb" />
    </div>
    <div class="search-line">
      <div class="select-box">
        <!--<input-select :selectTitle="selectTitle" :selectData="selectData" selectKey="status" @search="search" />-->
        <input-select :selectTitle="selectTitle" :selectData="selectData" selectKey="status" @search="search" />
      </div>
      <input-search :placeholder="searchPlaceholder" @search="searchKey" />
    </div>
    <table-main :selection=false :tableHead="tableHead" :operationArr="operationArr" :tableData="tableData" @toDetailsPage="toDetailsPage" @approveLine="approveLine" @unApproveLine="unApproveLine" @goToModifyPage="goToModifyPage" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import InputSearch from '../../components/Input/InputSearch'
import TableMain from '../../components/Table/TableMain'
import InputSelect from '../../components/Input/InputSelect'
import {api} from '../api/User'
import {errorHandler} from '../../utils/errorHandler'
import {bus} from '../../utils/bus'
import {nSuccess} from '../../utils/notice'

export default {
  components: {
    InputSelect,
    TableMain,
    InputSearch,
    Breadcrumb},
  name: 'need-handle',
  data () {
    return {
      breadcrumb: [{
        value: '用户中心',
        name: 'account-management'
      }, {
        value: '待办事项'
      }],
      selectTitle: '状态',
      selectData: [{
        key: '',
        label: '全部'
      }, {
        key: '0',
        label: '未处理'
      }, {
        key: '1',
        label: '已处理'
      }],
      selectTitle2: '审批结果',
      selectData2: [{
        key: '',
        label: '全部'
      }, {
        key: '1',
        label: '待审批'
      }, {
        key: '2',
        label: '审批通过'
      }, {
        key: '3',
        label: '审批驳回'
      }],
      searchPlaceholder: '审批单号',
      tableHead: [{
        prop: 'personName',
        label: '人员姓名'
      }, {
        prop: 'personPhone',
        label: '手机号'
      }, {
        prop: 'type',
        label: '类型'
      }, {
        prop: 'createTime',
        label: '提交时间'
      }, {
        prop: 'statusText',
        label: '状态'
      }],
      operationArr: ['modifySuggestions'],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestData: {
        responsiblePersonCode: '',
        searchKey: '',
        result: '',
        status: ''
      }
    }
  },
  created () {
    this.requestData.responsiblePersonCode = bus.global.accountCode
    this.getPage()
  },
  methods: {
    // 获取投诉建议分页
    getPage () {
      let reqData = this.requestData
      reqData.pageNum = this.pageNum
      reqData.pageSize = this.pageSize
      this.$axios.post(api.getSuggestionsPage, reqData)
        .then(res => {
          let data = res.data.data.list
          this.total = res.data.data.total
          data.map(v => {
            if (v.status === '0') {
              v.statusText = '未处理'
            } else if (v.status === '1') {
              v.statusText = '已处理'
            }
            v.createTime = v.createTime.slice(0, 19)
          })
          this.tableData = data
        })
        .catch(errorHandler('获取信息失败'))
    },

    // 人员审批分页
    getBaklogPage () {
      let reqData = this.requestData
      reqData.pageNum = this.pageNum
      reqData.pageSize = this.pageSize
      this.$axios.post(api.getBaklogPage, reqData)
        .then(res => {
          let data = res.data.data.list
          this.total = res.data.data.total
          data.map(v => {
            v.code = v.baklogCode
            if (v.status === '0') {
              v.status = '未处理'
            } else if (v.status === '1') {
              v.status = '已完成'
            }
            if (v.emergencyDegree === '1') {
              v.emergencyDegree = '低'
            } else if (v.emergencyDegree === '2') {
              v.emergencyDegree = '中'
            } else if (v.emergencyDegree === '3') {
              v.emergencyDegree = '高'
            }
            if (v.taskType === '1') {
              v.taskTypeText = '人员审批'
            } else if (v.taskType === '2') {
              v.taskTypeText = '住户审批'
            } else if (v.taskType === '3') {
              v.taskTypeText = '三方卡审批'
            }
            if (v.result === '1') {
              v.result = '待审批'
            } else if (v.result === '2') {
              v.result = '审批通过'
            } else if (v.result === '3') {
              v.result = '审批驳回'
            }
          })
          this.tableData = data
        })
        .catch(errorHandler('获取信息失败'))
    },
    search (v) {
      this.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },
    searchKey (v) {
      this.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    toDetailsPage (data) {
      this.$router.push({
        path: `/user_center/approval_details/${data.taskType}/${data.code}`
      })
    },
    approveLine (data) {
      if (data.taskType === '1') {
        this.$axios.post(api.approvePersonBaklog, {
          baklogCode: data.code
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.getPage()
              nSuccess('审批通过')
            }
          })
          .catch(errorHandler('审批失败'))
      } else if (data.taskType === '2') {
        this.$axios.post(`${api.approveBaklogByCode}/${data.code}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              this.getPage()
              nSuccess('审批通过')
            }
          })
          .catch(errorHandler('审批失败'))
      }
    },
    unApproveLine(code) {
      this.$axios.post(`${api.unApproveBaklogByCode}`, {
        baklogCode:  code
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.getPage()
            nSuccess('驳回成功')
          }
        })
        .catch(errorHandler('驳回失败'))
    },

    // 跳转修改投诉建议页面
    goToModifyPage (code) {
      this.$router.push({
        path: `/user_center/suggestions_details/${code}`
      })
    }
  }
}
</script>

<style scoped>
  .top {
    text-align: left;
    font-size: 20px;
    line-height: 70px;
  }
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .select-box {
    display: flex;
    justify-content: flex-start;
  }
  .select-box div {
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/User/NeedHandle.vue